import { Card, Row, Col } from "react-bootstrap";

import { formatCurrency, formatNumber } from "../../utils/functions";
import { SortenBezeichnung, SortenBetrag } from ".";

const DetailSorten = (props) => {
  let { auftrag, ...attribute } = props || {};

  if (!auftrag) return;
  const isVerkauf = !!String(auftrag.geschaeftsart).match(/VK$/);
  const header = isVerkauf ? "Bestellung" : "Ankauf";
  const order = auftrag.order || {};
  const auftragsDetails = auftrag.auftragsDetails || {};
  return <Card className="h-100" {...attribute}>
    <Card.Header>{header}</Card.Header>
    <Card.Body>
      <Row>
        <Col className="nowrap">Sorten {auftrag.kennziffer}</Col><Col className="nowrap">
          {auftrag.text
            ? auftrag.text
            : <SortenBezeichnung kennziffer={auftrag.kennziffer} name={order.name} />
          }
        </Col>
      </Row>
      <Row>
        <Col md="8" lg="6" className="nowrap">Betrag:</Col>
        <Col md="4" lg="3" className="nowrap text-end">
          <SortenBetrag kennziffer={auftrag.kennziffer} iso={order.name} betrag={auftrag.count} />
        </Col>
      </Row>
      <Row>
        <Col md="8" lg="6" className="nowrap">Kurs:</Col>
        <Col md="4" lg="3" className="nowrap text-end">{formatNumber(order.preis, { maximumFractionDigits: 4 })}</Col>
      </Row>
      <Row>
        <Col md="8" lg="6" className="nowrap">Kurswert:</Col>
        <Col md="4" lg="3" className="nowrap text-end">{formatCurrency(order.netto)}</Col>
      </Row>
      <Row>
        <Col md="8" lg="6" className="nowrap">Konditions&shy;änderung/Gebühr:</Col>
        <Col md="4" lg="3" className="nowrap text-end">{formatCurrency(auftragsDetails.konditionsAenderung)}</Col>
      </Row>
      <Row>
        <Col md="8" lg="6" className="nowrap">Versandkosten:</Col>
        <Col md="4" lg="3" className="nowrap text-end">{formatCurrency(order.versandkosten)}</Col>
      </Row>
      <Row>
        <Col md="8" lg="6" className="nowrap">Provision:</Col>
        <Col md="4" lg="3" className="nowrap text-end">{formatCurrency(auftragsDetails.provision)}</Col>
      </Row>
      <Row>
        <Col md="8" lg="6" className="nowrap">Gesamtbetrag:</Col>
        <Col md="4" lg="3" className="nowrap text-end">{formatCurrency(order.endsumme)}</Col>
      </Row>
    </Card.Body>
  </Card>;
};
export default DetailSorten;
